import { MixpanelPolicyPayload } from './generic-entity-types';

export interface ActionExitedPayload extends MixpanelPolicyPayload {
  action: string;
}

export function generateActionExitedProperties(payload: ActionExitedPayload): ActionExitedPayload {
  return payload;
}
